import { serverAPI } from "../../services/api/apiParams"
import Cookies from "universal-cookie"

const logout = async (setUser, history) => {
  try {
    await serverAPI.post("api/logout", {
      headers: {
        Accept: "application/json",
      },
    })
    const cookies = new Cookies()
    cookies.remove("auth_token")
    setUser({})
    history.push("/")
  } catch (e) {
    setUser({})
    console.log(e)
  }
}
export default logout
